<template>
  <!-- Page title -->
  <div class="page-title py-5 bg-custom-gradient">
    <div class="container">
      <div class="d-flex flex-lg-row flex-column align-items-center justify-content-between">
        <div><h3 class="text-white fw-bold">مواعيدي</h3></div>
        <form class="search-form d-lg-block d-none">
          <div class="d-flex flex-column flex-lg-row gap-3">
            <div class="position-relative">
              <div class="form-icon start">
                <i class="fa fa-search text-white"></i>
              </div>
              <input type="text" class="form-control bg-transparent text-white border-2 border-white" placeholder="البحث .." />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="container mt-5">
    <!-- Item -->
    <div class="row mb-4">
      <div class="col-lg-7 mx-auto px-lg-4 px-0">
        <!-- Filter -->
        <div class="d-flex justify-content-center">
          <nav>
            <div class="nav filter-group nav-tabs rounded-pill border-0 p-1" id="nav-tab" role="tablist">
              <button class="btn active d-flex px-4 align-items-center" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">
                <div class="svg-icon me-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21">
                    <g id="schedule" transform="translate(-1 -2)">
                      <rect id="Rectangle_27" data-name="Rectangle 27" width="20" height="18" rx="3" transform="translate(2 4)" fill="none" stroke="#3772ff" stroke-width="2" />
                      <circle id="Ellipse_16" data-name="Ellipse 16" cx="6" cy="6" r="6" transform="translate(11 11)" fill="#777e90" />
                      <path id="Path_49" data-name="Path 49" d="M17,14a1,1,0,0,1,1,1v1.586l1.207,1.207a1,1,0,0,1-1.414,1.414l-1.5-1.5A1,1,0,0,1,16,17V15A1,1,0,0,1,17,14Z" fill="#fff" />
                      <path id="Path_50" data-name="Path 50" d="M7,2A1,1,0,0,1,8,3V5A1,1,0,0,1,6,5V3A1,1,0,0,1,7,2Z" fill="#777e90" />
                      <path id="Path_51" data-name="Path 51" d="M17,2a1,1,0,0,1,1,1V5a1,1,0,0,1-2,0V3A1,1,0,0,1,17,2Z" fill="#777e90" />
                    </g>
                  </svg>
                </div>
                القادمة
              </button>
              <button class="btn d-flex px-4 align-items-center" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">
                <div class="svg-icon me-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                    <g id="Frame_1240" data-name="Frame 1240" transform="translate(-1.408 -1.407)">
                      <g id="event-add" transform="translate(0.408 0.407)">
                        <rect id="Rectangle_28" data-name="Rectangle 28" width="20" height="18" rx="3" transform="translate(2 4)" fill="none" stroke="#777e90" stroke-width="2" />
                        <path id="Path_54" data-name="Path 54" d="M7,2A1,1,0,0,1,8,3V7A1,1,0,0,1,6,7V3A1,1,0,0,1,7,2Z" transform="translate(0 -1)" fill="#777e90" />
                        <path id="Path_55" data-name="Path 55" d="M17,2a1,1,0,0,1,1,1V7a1,1,0,0,1-2,0V3A1,1,0,0,1,17,2Z" transform="translate(0 -1)" fill="#777e90" />
                        <path id="Path_56" data-name="Path 56" d="M13,10a1,1,0,0,0-2,0v2H9a1,1,0,0,0,0,2h2v2a1,1,0,0,0,2,0V14h2a1,1,0,0,0,0-2H13Z" transform="translate(12.707 -4.678) rotate(45)" fill="#777e90" />
                      </g>
                    </g>
                  </svg>
                </div>
                الملغية
              </button>
              <button class="btn d-flex px-4 align-items-center" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">
                <div class="svg-icon me-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                    <g id="event-scheduled" transform="translate(-1 -1)">
                      <rect id="Rectangle_29" data-name="Rectangle 29" width="20" height="18" rx="3" transform="translate(2 4)" fill="none" stroke="#777e90" stroke-width="2" />
                      <path id="Path_57" data-name="Path 57" d="M7,2A1,1,0,0,1,8,3V7A1,1,0,0,1,6,7V3A1,1,0,0,1,7,2Z" transform="translate(0 -1)" fill="#777e90" />
                      <path id="Path_58" data-name="Path 58" d="M17,2a1,1,0,0,1,1,1V7a1,1,0,0,1-2,0V3A1,1,0,0,1,17,2Z" transform="translate(0 -1)" fill="#777e90" />
                      <path id="Path_59" data-name="Path 59" d="M16.707,10.293a1,1,0,0,1,0,1.414l-5,5a1,1,0,0,1-1.414,0l-2.5-2.5a1,1,0,0,1,1.414-1.414L11,14.586l4.293-4.293A1,1,0,0,1,16.707,10.293Z" fill="#777e90" />
                    </g>
                  </svg>
                </div>
                المنتهية
              </button>
            </div>
          </nav>
          <button @click="showDatePicker = !showDatePicker" class="btn text-secondary d-flex align-items-center ms-auto border border-2 rounded-12px px-3 d-lg-flex d-none">
            <div class="svg-icon me-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14.506" viewBox="0 0 18 14.506">
                <g id="tune" transform="translate(-2.999 -4.245)">
                  <g id="Group_113" data-name="Group 113">
                    <path
                      id="Subtraction_2"
                      data-name="Subtraction 2"
                      d="M-1360-9686.477h-2.62a3.535,3.535,0,0,0,.144-1,3.524,3.524,0,0,0-.144-1h2.62a1,1,0,0,1,1,1A1,1,0,0,1-1360-9686.477Zm-9.38,0H-1376a1,1,0,0,1-1-1,1,1,0,0,1,1-1h6.619a3.509,3.509,0,0,0-.144,1,3.524,3.524,0,0,0,.144,1Z"
                      transform="translate(1380 9694.477)"
                      fill="#777e90"
                    />
                    <path id="Path_48" data-name="Path 48" d="M13.75,9.5A2.75,2.75,0,1,0,11,6.75,2.75,2.75,0,0,0,13.75,9.5Z" transform="translate(0.245 0.245)" fill="#777e90" />
                  </g>
                  <g id="Group_114" data-name="Group 114" transform="translate(2.999 13)">
                    <path id="Subtraction_2-2" data-name="Subtraction 2" d="M17,0h-2.62a3.543,3.543,0,0,1,0,2H17a1,1,0,1,0,0-2ZM7.621,0H1A1,1,0,1,0,1,2H7.621a3.538,3.538,0,0,1,0-2Z" transform="translate(18 4) rotate(180)" fill="#777e90" />
                    <path id="Path_48-2" data-name="Path 48" d="M13.75,9.5A2.75,2.75,0,1,1,16.5,6.75,2.75,2.75,0,0,1,13.75,9.5Z" transform="translate(-7.001 -3.75)" fill="#777e90" />
                  </g>
                </g>
              </svg>
            </div>
            تحديد التاريخ
          </button>
          <div class="position-relative d-lg-block d-none" v-if="showDatePicker">
            <div class="position-absolute end-100 top-100 mt-2 shadow-lg custom-datepicker primary-datepicker">
              <v-date-picker :attributes="attributes" class="h-100" is-expanded locale="ar" v-model="range" is-range :min-date="new Date()" />
            </div>
          </div>
        </div>
        <!-- Accoridons & dates -->
        <div class="mt-5">
          <h5 class="fs-5 fw-bold px-lg-0 px-2">كافة المواعيد</h5>
          <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <div v-for="date in dateList" :key="date" class="d-flex flex-lg-row flex-column gap-3 mb-3">
                <div :class="'bg-' + date.class" class="text-white fw-bold text-center history d-flex flex-lg-column align-items-center align-items-center justify-content-lg-center py-lg-0 py-2 ps-lg-0 ps-3 gap-lg-0 gap-1">
                  {{ date.date }}
                </div>

                <div class="accordion schedule-accordion ms-auto d-flex flex-column gap-3" id="accordionExample">
                  <AccordionItem v-for="user in date.users" :key="user" :item="user" />
                </div>
              </div>
            </div>
            <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">...</div>
            <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">...</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Modal :form_img="false" :is_alert="true" :alert_img="''" :modal_title="''" :name="'reMeet'">
    <div class="d-grid gap-2">
      <h3 class="fw-bold my-2 fs-4">قم بتحديد التاريخ الجديد</h3>
      <v-date-picker class="w-100 border border-2 py-3" locale="ar" v-model="range" :attributes="attributes" is-double-paned />
      <button data-bs-dismiss="modal" aria-label="Close" class="btn btn-primary rounded-pill py-2 fw-bold">حفظ</button>
    </div>
  </Modal>
</template>

<script>
import AccordionItem from '@/components/AccordionItem.vue'
import Modal from '@/components/Modal.vue'
import {ref} from '@vue/reactivity'

export default {
  name: 'Schedule',
  components: {
    AccordionItem,
    Modal,
  },
  setup() {
    const showDatePicker = ref(false)
    const dateList = ref([
      {
        date: '12SEPT',
        class: 'primary',
        users: [
          {
            id: 1,
            name: 'أحمد سمير',
            email: 'name@example.com',
            type: 'Convo about the site',
            time: '11:00PM - 12:00AM',
            duration: '30 دقيقة',
            platform: 'zoom',
            questions: [
              {
                id: 1,
                title: 'من هم المنافسين لك في المجال؟',
                answare: 'في الحقيقة لا منافسين لي في السوق لان المنتجات مميزه جدا . لكن لدي قرابة ال ٧٥ منافس',
              },
              {
                id: 2,
                title: 'ماهي ميزات منتجك؟',
                answare: 'لا ميزات لدي فأنا جديد في السوق ولا افهم معنى كلمة ميزات ابداً',
              },
              {
                id: 3,
                title: 'ملاحظات',
                answare: '',
              },
            ],
          },
          {
            id: 2,
            name: 'سمير احمد',
            email: 'name@example.com',
            type: 'Convo about the site',
            time: '11:00PM - 12:00AM',
            duration: '30 دقيقة',
            platform: 'zoom',
            questions: [
              {
                id: 1,
                title: 'من هم المنافسين لك في المجال؟',
                answare: 'في الحقيقة لا منافسين لي في السوق لان المنتجات مميزه جدا . لكن لدي قرابة ال ٧٥ منافس',
              },
              {
                id: 2,
                title: 'ماهي ميزات منتجك؟',
                answare: 'لا ميزات لدي فأنا جديد في السوق ولا افهم معنى كلمة ميزات ابداً',
              },
              {
                id: 3,
                title: 'ملاحظات',
                answare: '',
              },
            ],
          },
        ],
      },
      {
        date: '13DEC',
        class: 'secondary',
        users: [
          {
            id: 3,
            name: 'عماد بيك',
            email: 'name@example.com',
            type: 'Convo about the site',
            time: '11:00PM - 12:00AM',
            duration: '30 دقيقة',
            platform: 'zoom',
            questions: [
              {
                id: 1,
                title: 'من هم المنافسين لك في المجال؟',
                answare: 'في الحقيقة لا منافسين لي في السوق لان المنتجات مميزه جدا . لكن لدي قرابة ال ٧٥ منافس',
              },
              {
                id: 2,
                title: 'ماهي ميزات منتجك؟',
                answare: 'لا ميزات لدي فأنا جديد في السوق ولا افهم معنى كلمة ميزات ابداً',
              },
              {
                id: 3,
                title: 'ملاحظات',
                answare: '',
              },
            ],
          },
          {
            id: 4,
            name: 'مدحت عودة',
            email: 'name@example.com',
            type: 'Convo about the site',
            time: '11:00PM - 12:00AM',
            duration: '30 دقيقة',
            platform: 'zoom',
            questions: [
              {
                id: 1,
                title: 'من هم المنافسين لك في المجال؟',
                answare: 'في الحقيقة لا منافسين لي في السوق لان المنتجات مميزه جدا . لكن لدي قرابة ال ٧٥ منافس',
              },
              {
                id: 2,
                title: 'ماهي ميزات منتجك؟',
                answare: 'لا ميزات لدي فأنا جديد في السوق ولا افهم معنى كلمة ميزات ابداً',
              },
              {
                id: 3,
                title: 'ملاحظات',
                answare: '',
              },
            ],
          },
        ],
      },
    ])

    const attributes = ref([{}])
    return {dateList, showDatePicker, attributes}
  },
}
</script>

<style>
</style>